export const PROJECT_NAME = 'InkRouter Webapp';
export const SHORT_PROJECT_NAME = 'IR Webapp';

export default { PROJECT_NAME, SHORT_PROJECT_NAME };
